import { useMemo } from 'react'

import { useGetCustomFields } from '@/app/module/custom-fields/hooks/use-get-custom-fields'
import { PersonalizationType } from '@/app/types'

const contactFields = [
  {
    access: true,
    label: 'Contact first name',
    value: 'contact.firstName',
  },
  {
    access: true,
    label: 'Contact last name',
    value: 'contact.lastName',
  },
  {
    access: true,
    label: 'Contact phone number',
    value: 'contact.fullPhoneNumber',
  },
  {
    access: true,
    label: 'Contact language',
    value: 'contact.language',
  },
  {
    access: true,
    label: 'Contact ID',
    value: 'contact.id',
  },
]

export const usePersonalizationList = (): PersonalizationType => {
  const { data } = useGetCustomFields()

  return useMemo(
    () => ({
      contact: contactFields,
      customfields: (data?.allCustomfields || []).map(({ access, id, name }) => ({
        access,
        label: name,
        value: `customfields.${id}`,
      })),
    }),
    [data?.allCustomfields],
  )
}
